import React, {FC, useEffect, useState} from "react";
import {DropDownCompString, getKeyVal} from "../util/DropDownComp";
import {Position} from "../../models/Position";
import TickManager, {useSub} from "../../service/TickManager";
import AppUtil from "../../util/AppUtil";
import AppConstants from "../../util/AppConstants";
import {OptionWrapper, Pair} from "../../models/SGB";
import CollectionUtils from "../../util/CollectionUtils";
import {FuturePositions, PositionAnalyses} from "../../models/PositionAnalyses";
import GatewayService from "../../service/GatewayService";
import {CheckboxComponent} from "../util/CheckboxComponent";
import collectionUtils from "../../util/CollectionUtils";
import {useClients} from "../../context/ClientsContext";

interface Props {
    // chain:string,
}

function itm(buySell: Pair<string, string>) {
    return [buySell.first, buySell.second].map(it=>TickManager.getOption(it).intrinsic>0).filter(it=>it).length
}

function PairComp(props: { pairs: Array<Pair<string, string>>, text:string, }) {
    let pairs = props.pairs
    const [expand, setExpand] = useState(false);
    const [_, refresh] = useState(0)
    useSub(props.pairs.flatMap(e=>[e.first, e.second]), (_:any)=>refresh(new Date().getTime()))

    return <>
        <CheckboxComponent text={"expand"} actual={expand} val={expand} set={setExpand}/>
        <table>
            <thead>
            <tr><th>{props.text} ({props.pairs.length}) effective - {props.pairs.filter(it=>itm(it)==1).length}</th></tr>
            <tr>
                <th>buy</th>
                <th>extrinsic sell</th>
                <th>sell</th>
                <th>extrinsic buy</th>
                <th>extrinsic sqOff</th>
                <th>itm count</th>
            </tr>
            </thead>
            {expand && <tbody>
            {pairs.map(buySell => {
                const itmCount = itm(buySell)
                let sqOffExtrinsic = TickManager.getOption(buySell.first).extrinsicSell - TickManager.getOption(buySell.second).extrinsicBuy
                return <tr>
                    <td>{buySell.first}</td>
                    <td><Extrinsic symbol={buySell.first} isBuy={false}/></td>
                    <td>{buySell.second}</td>
                    <td><Extrinsic symbol={buySell.second} isBuy={true}/></td>
                    <td>{sqOffExtrinsic}</td>
                    <td>{itmCount}</td>
                </tr>
            })
            }
            </tbody>}
        </table>
        <br/>

    </>
}

function Extrinsic(props: { symbol: string, isBuy: boolean }) {
    // const [_, refresh] = useState(0)
    const option = TickManager.getOption(props.symbol)
    // useSub(props.symbol, (_:any)=>refresh(new Date().getTime()))
    return <>{props.isBuy ? option.extrinsicBuy : option.extrinsicSell}</>;
}

function LefOvers(props: { leftOvers: Array<string>, text: string, isBuy: boolean }) {
    let leftOvers = props.leftOvers
    const [expand, setExpand] = useState(false);
    useEffect(() => {
        setExpand(leftOvers.length!==0)
    // }, []);
    }, [props.leftOvers]);
    return <>
        <CheckboxComponent text={"expand"} actual={expand} val={expand} set={setExpand}/>
        <table>
            <thead>
            <tr>
                <th>{props.text} ({leftOvers.length}) effective itm are {itmCountLeftOver(leftOvers)}</th>
            </tr>
            <tr>
                <th>option</th>
                <th>extrinsic</th>
                {props.isBuy &&
                    <>
                        <th>corresponding Sell</th>
                        <th>extrinsic sell</th>
                    </>
                }
                <th>ITM</th>
            </tr>
            </thead>
            {expand && <tbody>
            {leftOvers.map(it => <tr>
                <td>{it}</td>
                <td><Extrinsic symbol={it} isBuy={!props.isBuy}/></td>
                {props.isBuy && <>
                    <td>{TickManager.getCorrespondingOption(it)}</td>
                    <td><Extrinsic symbol={TickManager.getCorrespondingOption(it)!!} isBuy={!props.isBuy}/></td>
                </>}
                <td>{(TickManager.getOption(it).intrinsic > 0) ? 1 : 0}</td>
            </tr>)}
            </tbody>}
        </table>
        <br/>

    </>
}

function itmCount(pairs: Array<Pair<string, string>>) {
    return pairs.filter(it=>itm(it)==1).length;
}

function itmCountLeftOver(lo : Array<string>){
    return lo.filter(it=>TickManager.getOption(it).intrinsic>0).length
}

function getExpiryQty(futureAnalyses: FuturePositions) {
    let pa = futureAnalyses.analyses
    return pa.buyFutures - pa.sellFutures + itmCount(pa.buyCallSellPut) - itmCount(pa.buyPutSellCall) + itmCount(pa.buyCallSellCall) - itmCount(pa.buyPutSellPut) +
        itmCountLeftOver(pa.leftOversBuyCalls) - itmCountLeftOver(pa.leftOversBuyPuts) +
        itmCountLeftOver(pa.leftOversSellPuts) - itmCountLeftOver(pa.leftOversSellCalls)
}

function Analyser(props: { futureAnalyses: FuturePositions | undefined }) {
    if (props.futureAnalyses === undefined) return <></>
    let pa = props.futureAnalyses.analyses
    let count = getExpiryQty(props.futureAnalyses)
    ;
    return <>
        <br/>
        {props.futureAnalyses.future} {TickManager.getFuture(props.futureAnalyses.future)?.miniTick.lastPrice} ({count}) <br/>
        <tr>
            <td>buy futures</td>
            <td>{pa.buyFutures}</td>
        </tr>
        <tr>
            <td>sell futures</td>
            <td>{pa.sellFutures}</td>
        </tr>
        <br/>

        <PairComp pairs={pa.buyCallSellPut} text={"buyCombo"}/>
        <PairComp pairs={pa.buyPutSellCall} text={"sellCombo"}/>
        <PairComp pairs={pa.buyCallSellCall} text={"bcsc"}/>
        <PairComp pairs={pa.buyPutSellPut} text={"bpsp"}/>

        <LefOvers leftOvers={pa.leftOversBuyCalls} text={"BuyCalls"} isBuy={true}/>
        <LefOvers leftOvers={pa.leftOversSellCalls} text={"SellCalls"} isBuy={false}/>
        <LefOvers leftOvers={pa.leftOversBuyPuts} text={"BuyPuts"} isBuy={true}/>
        <LefOvers leftOvers={pa.leftOversSellPuts} text={"SellPuts"} isBuy={false}/>
    </>
}

export default function PositionsDeepAnalyser() {
    const [client, setClient] = useState("");
    const [chain, setChain] = useState("");
    const [onlyLeftovers, setOnlyLeftovers] = useState(false);
    const [nettedOffConcern, setNettedOffConcern] = useState(false);
    const [positions, setPositions] = useState<Array<FuturePositions>>([])
    const { clients } = useClients();

    function refresh() {
        GatewayService.deepAnalyse(client).then(setPositions)
    }

    function getPositions() {
        return positions.filter(it=>{
            if (!onlyLeftovers)return true
            let leftOvers = it.analyses.leftOversSellPuts
                .concat(it.analyses.leftOversSellCalls)
                .concat(it.analyses.leftOversBuyCalls)
                .concat(it.analyses.leftOversBuyPuts)
            return leftOvers.length>0
        }).filter(it => !nettedOffConcern || getExpiryQty(it)!==0)
    }

    useEffect(() => {
        let arr = getPositions().map(it=>it.future)
        if (arr.length!==0)setChain(arr[0])
    }, [positions]);
    useEffect(() => {
        if (clients && clients.length > 0 && client === "") {
            setClient(clients[0]);
        }
    }, [clients, client]);

    useEffect(() => {
        if (client) {
            refresh()
        }
    }, [client]);

    function getClients() {
        return clients || [];
    }

    return <>
        <DropDownCompString text={"select client"} actual={client} arr={getKeyVal(getClients())} set={setClient}/>
        <CheckboxComponent text={"only leftovers"} actual={onlyLeftovers} val={onlyLeftovers} set={setOnlyLeftovers}/>
        <CheckboxComponent text={"net Off Concern"} actual={nettedOffConcern} val={nettedOffConcern} set={setNettedOffConcern}/>
        <button onClick={refresh}>refresh</button>
        <br/>
        <br/>
        {getPositions().map(it => <>
            <button onClick={()=>setChain(it.future)}>{it.future}({getExpiryQty(it)})</button><br/>
        </>)}

        <Analyser futureAnalyses={positions.find(it=> it.future===chain)} />
    </>
}

